import { PrismicRichText } from "@prismicio/react"
import { graphql } from "gatsby"
import {normalizeImageProps} from "../../utils/image"
import parse from "html-react-parser"
import * as React from "react"
import RoadsignCallout from "../../components/sections/RoadsignCalloutSection"
import { linkResolver } from "../../utils/link-resolver"

const PrismicCaseStudyDataBodyCallout = ({ primary }) => {
  const {
    button_url = {},
    button_text = "",
    heading = "",
    headingText = "",
    text = {},
    image = null,
  } = primary

  return (
    <RoadsignCallout
      heading={headingText || heading}
      text={<PrismicRichText linkResolver={linkResolver} field={text?.richText} />}
      buttonText={button_text}
      buttonUrl={button_url}
      image={normalizeImageProps(image)}
    />
  )
}
export default PrismicCaseStudyDataBodyCallout

export const query = graphql`
    fragment CaseStudyRoadsignCallout on PrismicCaseStudyDataBodyRoadsignCallout{
        slice_type
        slice_label
        __typename
        primary{
            headingText: heading
            text{
                html
                richText
            }
            button_url{
                url
                target
            }
            button_text
            image{
                alt
                gatsbyImageData(layout: CONSTRAINED, height: 300)
            }
        }
    }
`
